module.exports = __webpack_public_path__ + "img/showcase_red.030ee603.png";